jQuery(function ($) {

  // ---------------------------
  // Swiper preset init
  // ---------------------------
  function initBlogSwipers() {
    if (typeof Swiper === 'undefined') return;

    $('.blog-swiper').each(function () {
      const $root = $(this);
      if ($root.data('swiper-init')) return;

      const autoplayEnabled = String($root.data('swiper-autoplay')) === '1';
      const autoplayDelay   = parseInt($root.data('swiper-delay'), 10) || 3500;
      const loopEnabled     = String($root.data('swiper-loop')) === '1';

      const swiperEl = $root.find('.swiper')[0];
      const prevEl   = $root.find('.blog-swiper__nav--prev')[0];
      const nextEl   = $root.find('.blog-swiper__nav--next')[0];
      const pagEl    = $root.find('.blog-swiper__pagination')[0];

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: loopEnabled,
        speed: 450,
        navigation: { prevEl, nextEl },
        pagination: { el: pagEl, clickable: true },
        autoplay: autoplayEnabled ? { delay: autoplayDelay, disableOnInteraction: false } : false,
        breakpoints: {
          640:  { slidesPerView: 2.1, spaceBetween: 18 },
          1024: { slidesPerView: 3,   spaceBetween: 22 }
        }
      });

      $root.data('swiper-init', true);
      $root.data('swiper-instance', swiper);
    });
  }

  // ---------------------------
  // AJAX Load More
  // ---------------------------
  function initBlogLoadMore() {
    $('.blog-loadmore[data-blog-ajax="1"]').each(function () {
      const $wrap = $(this);
      if ($wrap.data('lm-init')) return;

      const $btn   = $wrap.find('.blog-loadmore__btn');
      const nonce  = $wrap.data('blog-nonce');

      let page     = parseInt($wrap.data('blog-page'), 10) || 1;
      let total    = parseInt($wrap.data('blog-total'), 10) || 1;
      let loading  = false;

      function setLoading(state) {
        loading = state;
        $btn.toggleClass('is-loading', state);
        $btn.prop('disabled', state);
        $btn.attr('aria-disabled', state ? 'true' : 'false');
      }

      $btn.on('click', function () {
        if (loading) return;
        if (page >= total) return;

        setLoading(true);

        const payloadRaw = $wrap.attr('data-blog-payload');
        let payload = {};
        try { payload = JSON.parse(payloadRaw); } catch (e) {}

        $.ajax({
          url: window.ajaxurl || '/wp-admin/admin-ajax.php',
          type: 'POST',
          dataType: 'json',
          data: {
            action: 'blog_load_more',
            nonce: nonce,
            page: page + 1,
            payload: payload
          }
        })
        .done(function (res) {
          if (!res || !res.success) return;

          const nextPage = res.data && res.data.page ? parseInt(res.data.page, 10) : (page + 1);
          const newTotal = res.data && res.data.total ? parseInt(res.data.total, 10) : total;

          // Append to block
          const $block  = $wrap.closest('section[data-blog-block]');
          const $target = $block.find('.blog__ajax-target').first();

          // Carousel: append slides to swiper
          if ($block.find('.blog-swiper').length) {
            const $swiperRoot = $block.find('.blog-swiper').first();
            const swiper = $swiperRoot.data('swiper-instance');
            const slidesHtml = (res.data && res.data.slides) ? res.data.slides : '';

            if (swiper && slidesHtml) {
              const $tmp = $('<div/>').html(slidesHtml);
              const slides = $tmp.children().toArray();
              swiper.appendSlide(slides);
            }
          } else {
            const html = (res.data && res.data.html) ? res.data.html : '';
            if (html) $target.append(html);
          }

          page = nextPage;
          total = newTotal;

          $wrap.data('blog-page', page);
          $wrap.data('blog-total', total);

          if (page >= total) {
            $btn.prop('disabled', true).attr('aria-disabled', 'true');
            $wrap.addClass('is-complete');
          }
        })
        .always(function () {
          setLoading(false);
        });
      });

      $wrap.data('lm-init', true);
    });
  }

  initBlogSwipers();
  initBlogLoadMore();

  $(document).on('ready ajaxComplete', function () {
    initBlogSwipers();
    initBlogLoadMore();
  });

});
